import type { ReactNode } from "react";

export function Heading({
  icon,
  children,
}: {
  icon: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="flex items-center gap-2 text-sm font-semibold text-stone-800 dark:text-stone-100">
      {icon}
      {children}
    </div>
  );
}
